/**
 * DEMO / TYMCZASOWE — limit "3 zmiany terminu na karnet szkółki pływackiej" nie jest jeszcze
 * śledzony przez backend (brak trwałego licznika w danych karnetu — `exercises` pokazuje
 * tylko AKTUALNY stan, nie historię zmian). To liczy się WYŁĄCZNIE lokalnie w przeglądarce
 * (localStorage), per urządzenie — nie odzwierciedla prawdziwego stanu z serwera i zeruje się
 * po zmianie przeglądarki/wyczyszczeniu danych.
 *
 * DO ZROBIENIA DOCELOWO: backend musi zwracać realny licznik wykorzystanych zmian terminu
 * (albo status exercise'u po zmianie zostaje w `exercises` z odrębnym statusem, żeby dało się
 * to policzyć kumulatywnie z danych — do ustalenia z backendem, patrz rozmowa z [data]).
 */

const STORAGE_KEY_PREFIX = "demo_karnet_change_term_count_";
export const DEMO_MAX_CHANGE_TERM = 3;

export function getUsedChangeTermCount(trhId: string): number {
  if (!trhId) return 0;
  const raw = localStorage.getItem(STORAGE_KEY_PREFIX + trhId);
  const parsed = raw ? parseInt(raw, 10) : 0;
  return Number.isFinite(parsed) ? parsed : 0;
}

export function incrementChangeTermCount(trhId: string): void {
  if (!trhId) return;
  const next = getUsedChangeTermCount(trhId) + 1;
  localStorage.setItem(STORAGE_KEY_PREFIX + trhId, String(next));
}

export function canChangeTermDemo(trhId: string): boolean {
  return getUsedChangeTermCount(trhId) < DEMO_MAX_CHANGE_TERM;
}

export function getRemainingChangeTermCount(trhId: string): number {
  return Math.max(0, DEMO_MAX_CHANGE_TERM - getUsedChangeTermCount(trhId));
}

/** Tylko do testów demo — resetuje licznik dla danego karnetu. */
export function resetChangeTermCountDemo(trhId: string): void {
  if (!trhId) return;
  localStorage.removeItem(STORAGE_KEY_PREFIX + trhId);
}

// DEMO — wystawiamy na window, żeby dało się odpalić z konsoli devtoolsów bez importów:
// resetKarnetDemoLimit("GLEDY3A1A"). Działa dopiero gdy ten moduł się załaduje (np. po
// otwarciu raz modala rezerwacji szkółki), więc jeśli konsola dalej nie widzi funkcji,
// wejdź najpierw w dowolną rezerwację karnetu szkółki i spróbuj ponownie — albo użyj
// wprost localStorage.removeItem("demo_karnet_change_term_count_<trhId>").
if (typeof window !== "undefined") {
  (window as any).resetKarnetDemoLimit = resetChangeTermCountDemo;
}
